<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1XjxvJ/tc-custom/9780226077086.jpg?1722568557347" alt="This image is the cover for the book Sovereignty & the Responsibility to Protect"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sovereignty & the Responsibility to Protect
      </h1>
      <p class="bookDescription body article font2">
        <p>In 2011, the United Nations Security Council adopted Resolution 1973, authorizing its member states to take measures to protect Libyan civilians from Muammar Gadhafi’s forces. In invoking the “responsibility to protect,” the resolution draws on the principle that sovereign states are responsible and accountable to the international community for the protection of their populations and that the international community can act to protect populations when national authorities fail to do so. The idea that sovereignty includes the responsibility to protect is often seen as a departure from the classic definition, but it actually has deep historical roots.           <br/> In <i>Sovereignty and the Responsibility to Protect</i>, Luke Glanville argues that this responsibility extends back to the sixteenth and seventeenth centuries, and that states have since been accountable for this responsibility to God, the people, and the international community. Over time, the right to national self-governance came to take priority over the protection of individual liberties, but the noninterventionist understanding of sovereignty was only firmly established in the twentieth century, and it remained for only a few decades before it was challenged by renewed claims that sovereigns are responsible for protection.           <br/> Glanville traces the relationship between sovereignty and responsibility from the early modern period to the present day, and offers a new history with profound implications for the present.<br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Luke Glanville
      </h2>
      
      <p class="authorDescription body article"><B>Luke Glanville</B> is a fellow in the Department of International Relations at the Australian National University. He lives in Canberra, Australia, and is coeditor of several books, including <I>Protecting the Displaced</I> and <I>The Responsibility to Protect and International Law</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f6be4fe4